import Css from "./style.module.scss";

import { TableCell } from "nlib/ui/Table";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import Badge from "nlib/ui/Badge";
import React from "react";
import UserStatuses from "const/UserStatuses";
import classNames from "classnames";

const THEMES = {
  [UserStatuses.PENDING]: "alternative",
  [UserStatuses.APPROVED]: "positive"
};

const StatusCell = ({ className, pendingInvite }) => {
  const { uiTexts } = useSelector(getTextsData);

  return (
    <TableCell className={classNames(Css.statusCell, className)}>
      <Badge
        theme={pendingInvite ? THEMES[UserStatuses.PENDING] : THEMES[UserStatuses.APPROVED]}>
        {pendingInvite ? uiTexts.pending : uiTexts.active}
      </Badge>
    </TableCell>
  );
};

export default React.memo(StatusCell);
